// Named export
export const islandTours = {
  "havelock-island": {
    title: "Havelock Island",
    subtitle: "Swaraj Dweep – The pristine island paradise of Andaman 🌴🏖️",
    heroImage: "/Images/tour/havelock.webp",
    intro: "Havelock Island — now officially known as Swaraj Dweep — is one of the most beautiful and popular islands in the Andaman and Nicobar Islands of India. It is famous for its white sandy beaches, crystal-clear waters, coral reefs, and lush green forests.",
    overview: {
      list: [
        "Location: Andaman and Nicobar Islands, India (about 70 km northeast of Port Blair)",
        "Official Name: Swaraj Dweep (renamed in 2018 in honor of Subhas Chandra Bose)",
        "District: South Andaman",
        "Area: Approximately 113 square kilometers",
        "Population: Around 6,000 residents (mostly Bengali settlers and local tribes)"
      ],
      // image: "/Images/tour/havelockOverview.jpg",
        images: [
        "/Images/tour/havelock.webp",
        "/Images/tour/havelockOverview.jpg",
        "/Images/tour/havelock-escape.webp",
      ]
    },
    highlights: [
      "Radhanagar Beach (Beach No. 7) – Voted one of Asia’s best beaches by Time Magazine; known for powdery white sand, turquoise water, and sunset views.",
      "Elephant Beach – Famous for snorkeling, scuba diving, and underwater coral gardens; reachable via short boat ride or forest trek.",
      "Kalapathar Beach – Quieter and less crowded; named after black rocks (“Kala Pathar”) along the shoreline."
    ],
    location: [
      "Situated about 70 km northeast of Port Blair, South Andaman.",
      "Accessible by ferry from Port Blair; nearest airport is Veer Savarkar International Airport (Port Blair)."
    ],
    howToReach: [
      {
        from: "Port Blair",
        details: [
          "By Ferry: From Port Blair to Havelock (Swaraj Dweep) — about 2.5 to 3 hours by government or private ferry.",
          "By Air: No direct airport on the island. Nearest airport is Veer Savarkar International Airport (Port Blair)."
        ]
      }
    ],
    thingsToDo: {
      list: [
        "Scuba Diving: Dive sites include The Wall, Dixon’s Pinnacle, and Lighthouse.",
        "Snorkeling: Explore colorful coral reefs and marine life just a few meters offshore.",
        "Kayaking: Explore mangrove creeks on guided night or bioluminescence kayaking tours.",
        "Trekking: Trek to Elephant Beach or explore forest trails.",
        "Fishing & Boating: Enjoy sport fishing and sunset cruises."
      ],
    //   image: "/Images/tour/havelockThings.webp"
    },
    facilities: [
      "Luxury resorts, mid-range hotels, budget eco-huts, and backpacker hostels available.",
      "Basic amenities like restaurants, shops, and ATMs available on island.",
      "No direct hospital — minor medical facilities available; serious cases handled in Port Blair."
    ],
    bestTime: [
      "October to May – Ideal for beach activities and diving.",
      "June to September – Monsoon season; heavy rains but fewer tourists."
    ],
    travelTips: [
      "Carry cash (ATMs are limited).",
      "Plastic use is restricted—carry reusable bottles.",
      "Respect local customs and marine life (no coral collection).",
      "Book ferries and accommodation in advance during peak season."
    ]
  },

  "neil-island": {
  title: "Neil Island",
  subtitle: "Shaheed Dweep – The tranquil island retreat of Andaman 🌅🌴",
  heroImage: "/Images/tour/neilIsland.jpg",
  intro: "Neil Island (Now known as Shaheed Dweep) is one of the most beautiful and peaceful islands in the Andaman & Nicobar Islands, India. It is located about 37 km south of Port Blair, the capital of the Andaman Islands, and can be reached by ferry in about 1 to 1.5 hours.",
  overview: {
    list: [
      "Neil Island is known for its serene beaches, clear waters, coral reefs, and lush greenery.",
      "Compared to Havelock (Swaraj Dweep), it’s quieter and less commercial, making it ideal for travelers who want to relax and enjoy nature."
    ],
    // image: "/Images/tour/neilOverview.jpg",
        images: [
        "/Images/tour/neilIsland.jpg",
        "/Images/tour/Neil-Island.jpeg",
        "/Images/tour/neilOverview.jpg",
      ]
  },
  highlights: [
    "Laxmanpur Beach – Famous for sunset views. White sandy beach with coral formations. Great for photography and evening walks.",
    "Bharatpur Beach – Near the jetty; most popular beach for water sports. Activities: glass-bottom boat rides, snorkeling, and jet skiing. Best beach for swimming due to shallow waters.",
    "Sitapur Beach – Known for stunning sunrise views. Offers a peaceful, scenic setting with fewer crowds.",
    "Natural Bridge (Howrah Bridge) – A natural rock formation shaped like a bridge. Best visited during low tide to explore marine life around the area."
  ],
  howToReach: [
    {
      from: "Port Blair",
      details: [
        "By ferry (Government or private ferries like Makruzz, Green Ocean, or Nautika).",
        "Travel time: ~1–1.5 hours."
      ]
    },
    {
      from: "Havelock Island",
      details: [
        "By ferry in about 45 minutes."
      ]
    }
  ],
  thingsToDo: {
    list: [
      "Snorkeling and scuba diving to see coral reefs and tropical fish.",
      "Cycling around the island (bicycles are easily available for rent).",
      "Relaxing at beaches and watching sunrise/sunset.",
      "Visiting small local markets for handicrafts and souvenirs."
    ],
    // image: "/Images/tour/neilThings.webp"
  },
  facilities: [
    "Accommodation ranges from budget huts to luxury resorts.",
    "Fresh seafood is a highlight — especially at local beachside cafes."
  ],
  bestTime: [
    "October to May – ideal weather for sightseeing and water activities.",
    "Avoid June to September (monsoon season) due to rough seas."
  ],
  travelTips: [
    "Carry sunscreen, hat, sunglasses, and reusable water bottles.",
    "Book ferries in advance during peak season.",
    "Respect local customs and natural habitats; avoid littering."
  ]
},

  "ross-smith": {
    title: "Ross and Smith Islands",
    subtitle: "A breathtaking twin-island paradise connected by a natural sandbar 🌊🏝️",
    heroImage: "/Images/tour/rosssmithislands.webp",
    intro: "Ross and Smith Islands are a breathtaking twin-island pair located in the North Andaman region, near Diglipur, about 300 km from Port Blair. They are among the most scenic and unique destinations in the Andaman & Nicobar Islands — two separate islands connected by a natural sandbar that appears and disappears with the tides. 🌊🏝️",
    overview: {
      list: [
        'Ross and Smith Islands are often called the “Twin Islands of Andaman.”',
        'They are connected by a white sandbar, which allows visitors to walk from one island to the other when the tide is low.',
        'The area is part of the North Andaman group and lies close to Ariel Bay Jetty, Diglipur.',
        'Famous for crystal-clear turquoise water, lush green forests, and coral reefs, these islands are perfect for nature lovers, honeymooners, and photographers.'
      ],
      // image: '/Images/tour/rossSmithOverview.webp',
        images: [
        "/Images/tour/ross-boat.webp",
        "/Images/tour/ross-best.jpg",
        "/Images/tour/ross-andaman.webp",
      ]
    },
    highlights: [
      'Natural Sandbar Connection – the main attraction; an incredible natural phenomenon.',
      'Untouched Beaches – clean, quiet, and uncrowded.',
      'Snorkeling and Swimming – clear shallow waters ideal for beginners.',
      'Turtle Nesting Sites – nearby areas often see nesting of olive ridley and green turtles.',
      'Mangrove Forests and Coral Reefs – rich biodiversity both above and below water.'
    ],
    location: [
      'Situated 20 km from Diglipur town in North Andaman.',
      'Accessible via Ariel Bay Jetty, from where boats take you to the islands in 15–20 minutes.'
    ],
    howToReach: [
      { 
        from: 'Port Blair', 
        details: [
          'By Road: Around 12 hours (300 km) via Andaman Trunk Road (ATR) — scenic but long journey.',
          'By Ferry: Government ferries operate between Port Blair → Mayabunder → Diglipur (takes around 10–12 hours).',
          'By Helicopter: Limited helicopter service available (subject to weather and availability).'
        ]
      },
      {
        from: 'Diglipur',
        details: [
          'Hire a speedboat from Ariel Bay Jetty (15–20 minutes ride).',
          'Entry permit required (can be arranged locally).'
        ]
      }
    ],
    thingsToDo: {
      list: [
        'Walk on the Sandbar connecting the twin islands.',
        'Swimming and Snorkeling in clear lagoon waters.',
        'Relax on the beach and enjoy the natural scenery.',
        'Photography – the sandbar is one of the most photogenic spots in Andaman.',
        'Trekking nearby to Saddle Peak National Park (highest point in Andamans).'
      ],
    //   image: '/Images/tour/rossSmithThings.webp'
    },
    facilities: [
      'Small changing rooms and eco-huts available.',
      'Limited refreshments — advisable to carry snacks and water.',
      'No overnight stays allowed on the islands (you can stay in Diglipur town).'
    ],
    bestTime: [
      'October to April – best season for clear weather, calm sea, and beach activities.',
      'Avoid June to September (monsoon) due to high tides and restricted boat services.'
    ],
    travelTips: [
      'Permit is required to visit (obtained at Diglipur).',
      'Carry sunscreen, hat, sunglasses, and drinking water.',
      'Visit in the morning hours when the sandbar is visible.',
      'Maintain cleanliness — no littering or plastic allowed.'
    ]
  },

"north-bay": {
  title: "North Bay Island",
  subtitle: "Coral Island – The underwater paradise of Andaman 🏝️🪸",
  heroImage: "/Images/tour/northBayIsland.jpg",
  intro: "North Bay Island, often called the “Coral Island”, is famous for its underwater coral reefs, vibrant marine life, and water adventure activities. It lies just 30 minutes by boat from Port Blair, usually paired with a visit to Ross Island (Netaji Subhash Chandra Bose Island).",
  highlights: [
    "One of the best places for water sports in the Andamans.",
    "The picture of the North Bay Lighthouse appears on the Indian 20 Rupee Note.",
    "Crystal-clear waters and colorful coral gardens make it a snorkeling and scuba diving paradise."
  ],
  attractions: [
    "Coral Viewing – Take a glass-bottom boat ride to see live corals, tropical fish, and marine plants without getting wet.",
    "Scuba Diving – Ideal for beginners and certified divers alike. Dive to see clownfish, parrotfish, sea anemones, and vivid coral formations.",
    "Sea Walk – Unique experience where visitors walk on the seabed, surrounded by fish and corals.",
    "Snorkeling – Shallow and safe waters make it great for beginners.",
    "Lighthouse Viewpoint – Climb up to the North Bay Lighthouse for a panoramic view of Port Blair and Ross Island."
  ],
  howToReach: [
    {
      from: "Port Blair",
      details: [
        "From Aberdeen Jetty (Port Blair) by boat/ferry — takes around 25–30 minutes.",
        "Most tours include a combo trip to Ross Island + North Bay Island (half-day excursion)."
      ]
    }
  ],
  thingsToDo: {
    list: [
      "Glass-bottom boat rides",
      "Scuba diving",
      "Snorkeling",
      "Sea walk",
      "Jet skiing",
      "Photography at the lighthouse"
    ],
    // image: "/Images/tour/northBayThings.webp"
  },
  bestTime: [
    "October to May – perfect for clear waters and outdoor activities.",
    "Avoid monsoon months (June to September) as the sea can be rough."
  ],
  travelTips: [
    "Carry swimwear, an extra set of clothes, and sunscreen.",
    "Water sports are paid separately from the entry ticket.",
    "Food stalls are limited, so carry light snacks and water.",
    "No accommodation — only a day trip destination."
  ]
},
"baratang": {
  title: "Baratang Island",
  subtitle: "Adventure meets nature in the heart of Andaman 🌋🏝️",
  heroImage: "/Images/tour/baratangIsland.jpg",
  intro: "Baratang Island is one of the most adventurous and unique destinations in the Andaman & Nicobar Islands, India. It lies about 100 km north of Port Blair and is famous for its Limestone Caves, Mud Volcanoes, Mangrove Creeks, and Tribal Reserves. It’s a perfect day-trip destination for those who want to explore the natural wonders and offbeat beauty of the Andamans.",
  overview: {
    list: [
      "Baratang Island offers a mix of adventure, nature, and culture — from boat rides through mangrove tunnels to exploring mysterious caves.",
      "Unlike the beachy vibe of Havelock or Neil, Baratang shows a different side of the Andamans — raw, rural, and full of natural marvels."
    ],
    // image: "/Images/tour/baratangOverview.jpg",
            images: [
        "/Images/tour/baratang-mud-volcano.webp",
        "/Images/tour/baratang-nicobar.webp",
        "/Images/tour/baratang-luxury.jpg",
      ]
  },
  attractions: [
    "🪨 Limestone Caves – One of the main highlights of Baratang. Formed by natural sedimentation over millions of years. The caves are filled with stalactites and stalagmites in stunning shapes. Reachable by a boat ride through dense mangrove creeks followed by a short jungle trek (~1 km). Carry a flashlight and wear comfortable footwear.",
    "🌋 Mud Volcano – A rare natural phenomenon in India, found only in Baratang. The volcano occasionally oozes mud and gas bubbles, creating small craters. Though not spectacular visually, it’s geologically fascinating.",
    "🌿 Mangrove Creek Safari – Scenic boat ride through narrow mangrove tunnels leading to the limestone caves. Offers a peaceful and picturesque experience — perfect for photography.",
    "🏝️ Baludera Beach – A quiet and less-crowded beach ideal for relaxation. Gentle waves and clean surroundings make it a good picnic spot."
  ],
  howToReach: [
    {
      from: "Port Blair",
      details: [
        "Distance from Port Blair: ~100 km (4–5 hours by road).",
        "Route passes through the Andaman Trunk Road (ATR) and Jarawa Tribal Reserve (you’ll travel in a government-convoy system for safety).",
        "After reaching Nilambur Jetty, a short ferry ride takes you to Baratang Island."
      ]
    }
  ],
  timings: [
    "Travel is allowed only in fixed convoys, typically:",
    "7:00 AM (first convoy from Port Blair)",
    "9:00 AM or later (return convoy)",
    "You need to start early in the morning and return by evening."
  ],
  bestTime: [
    "October to May – pleasant weather, best for sightseeing and boating.",
    "Avoid June–September (monsoon season) due to rough roads and high tides."
  ],
  travelTips: [
    "Carry packed food and water, as restaurants are limited.",
    "Photography of Jarawa Tribes is strictly prohibited (the area is protected by law).",
    "Wear light clothes, a hat, and trekking shoes.",
    "The trip is usually a full-day excursion from Port Blair."
  ]
},
"jolly-buoy": {
  title: "Jolly Buoy Island",
  subtitle: "Part of Mahatma Gandhi Marine National Park – The living coral paradise of Andaman 🪸🏝️",
  heroImage: "/Images/tour/jolly-buoy.jpg",
  intro: "Jolly Buoy Island is a protected marine island located in the Mahatma Gandhi Marine National Park, near Wandoor, about 30 km southwest of Port Blair. It’s famous for its crystal-clear waters, colorful coral reefs, and rich marine life, making it one of the best spots for snorkeling and glass-bottom boating in the entire Andaman region.",
  highlights: [
    "A no-plastic zone and eco-protected island maintained by the Forest Department.",
    "The island is open to visitors only for a few months a year to protect coral life.",
    "Known for its vibrant coral reefs, tropical fish, and pristine beach with turquoise waters."
  ],
  attractions: [
    "Glass-Bottom Boat Ride – The most popular activity. Lets you see live corals, starfish, sea cucumbers, and colorful fish without entering the water.",
    "Snorkeling – Shallow waters make it ideal for beginners. Offers a close-up view of stunning coral gardens and marine biodiversity.",
    "Beach Relaxation – White sandy shores and clear blue water — perfect for swimming and relaxing.",
    "Photography – The island offers breathtaking photo opportunities with its natural colors and coral-rich underwater life."
  ],
  howToReach: [
    {
      from: "Port Blair",
      details: [
        "From Port Blair, drive about 30 km (1 hour) to Wandoor Jetty.",
        "From Wandoor, take a government boat (about 45 minutes ride) to reach Jolly Buoy Island."
      ]
    }
  ],
  entryRules: [
    "Special entry permit required (obtained from the Tourism Office or Forest Department in Port Blair).",
    "Plastic is strictly banned – even water bottles and chips packets are not allowed.",
    "Drinking water is provided in glass bottles or reusable containers."
  ],
  timings: [
    "Open Season: Usually from October to May.",
    "(During monsoon, Jolly Buoy is closed and Red Skin Island nearby is opened as an alternative.)",
    "Boats operate from Wandoor Jetty between 8:00 AM – 2:00 PM (day trips only)."
  ],
  bestTime: [
    "November to April – calm sea and clear underwater visibility.",
    "Avoid monsoon season (June–September) due to closure."
  ],
  travelTips: [
    "Book permits 1 day in advance through a local travel agent or tourism office.",
    "Carry food, reusable water bottle, sunscreen, hat, and towel.",
    "No stay facilities — only a day excursion.",
    "Respect coral life — no touching or collecting shells/corals."
  ]
},


};
